class AboutLaunchRoadmap extends HTMLElement {
  connectedCallback() {
    this._openBtn = this.querySelector('[data-open-roadmap]');
    this._closeBtn = this.querySelector('[data-close-roadmap]');
    this._card = this.querySelector('[data-launch-card]');
    this._roadmap = this.querySelector('[data-roadmap]');
    this._roadmapContent = this.querySelector('[data-roadmap-content]');
    this._levelsTemplate = this.querySelector('[data-levels-template]');
    this._roadmapLoaded = false;

    this._handleOpen = this._open.bind(this);
    this._handleClose = this._close.bind(this);

    this._openBtn?.addEventListener('click', this._handleOpen);
    this._closeBtn?.addEventListener('click', this._handleClose);

    // Preload only the bg image that matches the current viewport.
    // loading="lazy" prevents these from blocking page load, but we still
    // want them cached before the user clicks — so we match the <source>
    // media queries ourselves and fire a single Image() fetch.
    this._preloadBgImage();
  }

  disconnectedCallback() {
    this._openBtn?.removeEventListener('click', this._handleOpen);
    this._closeBtn?.removeEventListener('click', this._handleClose);
  }

  // Returns the srcset/src string that matches the current viewport,
  // mirroring the <source media="..."> order in the <picture> element.
  _getMatchingBgSrc() {
    const picture = this._roadmap?.querySelector('picture');
    if (!picture) return null;
    for (const source of picture.querySelectorAll('source')) {
      const media = source.getAttribute('media');
      if (!media || window.matchMedia(media).matches) {
        return source.getAttribute('srcset');
      }
    }
    return picture.querySelector('img')?.getAttribute('src') ?? null;
  }

  _preloadBgImage() {
    const src = this._getMatchingBgSrc();
    if (src) new Image().src = src;
  }

  _open() {
    if (!this._roadmapLoaded && this._levelsTemplate && this._roadmapContent) {
      this._roadmapContent.appendChild(this._levelsTemplate.content.cloneNode(true));
      this._roadmapLoaded = true;
    }

    // Browsers don't reliably re-evaluate <picture> <source> selection when an
    // element transitions out of display:none — set img.src explicitly so the
    // correct viewport image (desktop / tablet / mobile) always loads.
    const src = this._getMatchingBgSrc();
    const img = this._roadmap?.querySelector('picture img');
    if (img && src) img.src = src;

    this._card.hidden = true;
    this._roadmap.hidden = false;
    this._roadmap.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  _close() {
    this._roadmap.hidden = true;
    this._card.hidden = false;
    this._card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

customElements.define('about-launch-roadmap', AboutLaunchRoadmap);
